















import Vue, { PropType } from 'vue';
export default Vue.extend({
  name: 'QuillToolbar',

  props: {
    formats: Array as PropType<string[]>
  }
});
